import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import styles from '../../styles/admin.module.css';

function Admin() {
  const navigate = useNavigate();

  const adminOptions = [
    {
      title: 'All Users',
      path: '/admin/allusers',
      icon: '👥',
      description: 'View and manage all registered users'
    },
    {
      title: 'All Products',
      path: '/admin/allproducts',
      icon: '📦',
      description: 'View and manage all products'
    },
    {
      title: 'Pending Orders',
      path: '/admin/allorders?orders=pending',
      icon: '⏳',
      description: 'View all pending orders'
    },
    {
      title: 'Confirmed Orders',
      path: '/admin/allorders?orders=confirmed',
      icon: '✅',
      description: 'View all confirmed orders'
    },
    {
      title: 'Processing Orders',
      path: '/admin/allorders?orders=processing',
      icon: '⚙️',
      description: 'View all processing orders'
    },
    {
      title: 'Shipped Orders',
      path: '/admin/allorders?orders=shipped',
      icon: '🚚',
      description: 'View all shipped orders'
    },
    {
      title: 'Delivered Orders',
      path: '/admin/allorders?orders=delivered',
      icon: '📥',
      description: 'View all delivered orders'
    },
    {
      title: 'Cancelled Orders',
      path: '/admin/allorders?orders=cancelled',
      icon: '❌',
      description: 'View all cancelled orders'
    }
  ];

  return (
    <div className={styles.adminContainer}>
      <Navbar />
      
      <div className={styles.adminContent}>
        <div className={styles.adminHeader}>
          <h1 className={styles.adminTitle}>Admin Dashboard</h1>
          <p className={styles.adminSubtitle}>Welcome back, Admin! Choose a category to manage</p>
        </div>

        <div className={styles.adminGrid}>
          {adminOptions.map((option, index) => (
            <button
              key={index}
              type="button"
              className={styles.adminCard}
              onClick={() => navigate(option.path)}
            >
              <div className={styles.cardIcon}>{option.icon}</div>
              <h3 className={styles.cardTitle}>{option.title}</h3>
              <p className={styles.cardDescription}>{option.description}</p>
              <span className={styles.cardArrow}>→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Admin;